import { api } from "./api";

export const auth = {
  loginPath: `${api.host}/auth/access/login`,
  registerPath: `${api.host}/auth/access/register`,
  registerConfirmPath: `${api.host}/auth/access/register/confirm`,
  passwordResetPath: `${api.host}/auth/access/password/reset`,
  passwordUpdatePath: `${api.host}/auth/access/password/update`,
};
